import { render, staticRenderFns } from "./SidebarArtist.vue?vue&type=template&id=4ca4e80d&scoped=true"
import script from "./SidebarArtist.vue?vue&type=script&lang=js"
export * from "./SidebarArtist.vue?vue&type=script&lang=js"
import style0 from "./SidebarArtist.vue?vue&type=style&index=0&id=4ca4e80d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca4e80d",
  null
  
)

export default component.exports